<script setup lang="ts">
import { type FrontendPathwayEvent, usePathwayEvents } from '@/composables/game/pathway-events'
import { PATHWAY_EVENT_TYPE } from '@/types/shared/player-config'
import ClientDealCard from '@/components/ClientDealCard.vue'
import { computed, ref } from 'vue'
import type { Nullable } from '@/types/shared/common'
import ClientDealDetails from '@/components/ClientDealDetails.vue'

const { pathwayEvents: clientDeals } = usePathwayEvents(PATHWAY_EVENT_TYPE.CLIENT_DEALS)
const selectedClientDeal = ref<Nullable<FrontendPathwayEvent>>(null)

const visibleDeals = computed(() => clientDeals.value.filter(deal => !deal.hidden))

function onDetailsBack() {
  selectedClientDeal.value = null
}
</script>

<template>
  <Transition
    name="fade-fast"
    mode="out-in"
  >
    <div
      v-if="!selectedClientDeal"
      class="flex flex-col px-4 py-6 w-full relative flex-1"
    >
      <img
        class="size-[144px] object-cover mx-auto"
        src="@/assets/images/client-deals/main-icon.webp"
        alt="Client Deals"
      >
      <div
        class="mt-3 text-center text-light-white font-pilat uppercase text-[36px] leading-[36px] font-bold text-shadow-2"
      >
        Client Deals
      </div>
      <div class="mt-2 text-center text-white/60 text-sm font-semibold">
        Complete each step of the deal to earn rewards
      </div>
      <div
        class="w-full mt-9 flex"
        :class="{'flex-1': !visibleDeals.length}"
      >
        <div
          v-if="visibleDeals.length > 0"
          class="w-full grid grid-cols-2 gap-4"
        >
          <ClientDealCard
            v-for="clientDeal in visibleDeals"
            :key="clientDeal.id"
            class="scale-in"
            :client-deal="clientDeal"
            @click="selectedClientDeal = clientDeal"
          />
        </div>
        <div
          v-else
          class="flex-1 items-center justify-center flex flex-col text-light-white text-[20px] leading-7 font-bold"
        >
          <div>No new clients.</div>
          <div class="text-center">
            Keep an eye out for new deals
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="relative w-full flex-1 pt-6"
    >
      <ClientDealDetails
        :client-deal="selectedClientDeal"
        @back="onDetailsBack"
      />
    </div>
  </Transition>
</template>

<style scoped>

</style>